module.exports = __webpack_public_path__ + "static/media/stairs4.bf89dc9f.png";